import {
  Directive,
  Input,
  HostListener,
  OnInit,
  EventEmitter,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
export class FormValidationDirective implements OnInit {
   formGroup: FormGroup;
   validSubmit = new EventEmitter<any>();
/**
 * @return {?}
 */
onSubmit() {
    this.markAsTouchedAndDirty(this.formGroup);
    if (this.formGroup.valid) {
      this.validSubmit.emit(this.formGroup.value);
    }
  }
/**
 * @param {?} formGroup
 * @return {?}
 */
markAsTouchedAndDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      if (formGroup.controls[key] instanceof FormGroup) {
        this.markAsTouchedAndDirty( /** @type {?} */((formGroup.controls[key] as FormGroup)));
      } else {
        formGroup.controls[key].markAsDirty();
        formGroup.controls[key].markAsTouched();
        formGroup.controls[key].updateValueAndValidity();
      }
    });
  }
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: "form[formGroup]"
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'formGroup': [{ type: Input },],
'validSubmit': [{ type: Output },],
'onSubmit': [{ type: HostListener, args: ["submit", ] },],
};
}

function FormValidationDirective_tsickle_Closure_declarations() {
/** @type {?} */
FormValidationDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormValidationDirective.ctorParameters;
/** @type {?} */
FormValidationDirective.propDecorators;
/** @type {?} */
FormValidationDirective.prototype.formGroup;
/** @type {?} */
FormValidationDirective.prototype.validSubmit;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ~/ng-bootstrap-form-validation/ng-bootstrap-form-validation/src/lib/Directives/form-validation.directive.ts